import useAuthStore from "@/store/useAuthStore";
import { PAGE_URL } from "@/utils/constants";
import { useRouter } from "next/router";
import { useCallback, useEffect, useMemo } from "react";

export default function ProtectedRoutes() {
  const { user } = useAuthStore();
  const router = useRouter();

  const isNotHR = useMemo(
    () => !user?.profile?.["cognito:groups"]?.includes("Admin") && router.pathname.includes("hr"),
    [router, user],
  );

  const geIfHR = useCallback(() => {
    if (isNotHR && user?.profile) {
      router.push(PAGE_URL.notFound);
    }
  }, [user, router]);

  useEffect(() => {
    geIfHR();
  }, [router, user]);

  if(isNotHR) return <div className="fixed top-0 left-0 right-0 bottom-0 bg-card z-[1030]"/> // karna lama bgt proses ke not found nya, gini dulu aja yak, blank item dulu menjelang ke not found

  return null;
}
